export default __webpack_public_path__ + "dist/media/Copy.7e65f6ec.svg";